// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationTemplateModal_container__CGau8","buttons":"ConfirmationTemplateModal_buttons__unVb0"};